import { render, staticRenderFns } from "./CollectDetail.vue?vue&type=template&id=9fef8e60&scoped=true&"
import script from "./CollectDetail.vue?vue&type=script&lang=js&"
export * from "./CollectDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectDetail.vue?vue&type=style&index=0&id=9fef8e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fef8e60",
  null
  
)

export default component.exports